<template>
    <div>
        <b-modal 
        v-model="modalShow"
        id="modal-score-teacher" :centered="true" hide-footer    @hide="handleHideModal">
            <template #modal-header v-if="idCalification == 0">
                <img class="close" src="@/assets/img/close_red.png" @click="getClose()">
                <h6 class="sub-title"><span class="sub-title-modal">{{$t('modals.score-teacher.sub-title')}}</span></h6>
            </template>
            <template #modal-header v-else>
                <img class="close" src="@/assets/img/close_red.png" @click="getClose()">
                <h6 class="sub-title"><span class="sub-title-modal">{{$t('modals.score-teacher.sub-title-with-calification')}}</span></h6>
            </template>
            <section v-if="idCalification == 0">
                <b-row class="align-items-center mb-3">
                    <b-col>
                        <div class="d-flex align-items-center">
                            <b-avatar
                                variant="light"
                                :src="photoTeacher ? photoTeacher : urlPhoto.PHOTO_TEACHER_DEFAULT"
                                size="4.2rem"
                            ></b-avatar>
                            <h6 class="bold mb-0 pl-3" style="font-size:15px">{{nameTeacher}}</h6>
                        </div>
                    </b-col>
                    <b-col>
                        <b-form-rating v-model="ratingValue" stars="5" no-border size="lg"></b-form-rating>
                        <small v-if="showRatingError && !ratingValue" class="text-danger d-block mt-1">{{$t('modals.score-teacher.validation-required')}}</small>
                    </b-col>
                </b-row>
                <label class="bold" style="font-size:13px">{{$t('modals.score-teacher.text-comment')}}</label>
                <b-row>
                    <b-col>
                        <b-form-group class="mb-0">
                            <b-form-textarea
                            v-model="comment"
                                rows="6"
                                no-resize
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col style="max-width: 280px">
                        <p>{{$t('modals.score-teacher.p1')}}</p>
                        <p>{{$t('modals.score-teacher.p2')}}</p>
                    </b-col>
                </b-row>
                <div class="text-center">
                    <b-button @click="registerScore" :class="{ loading: isLoading }" :disabled="isLoading" variant="primary">{{$t('modals.score-teacher.btn-1')}}</b-button>
                </div>
            </section>
        </b-modal>
    </div>   
</template>

<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { IMAGENES } from '@/assets/js/appConstants';
export default {
	name:"modalRecommend",
	data() {
		return {
            urlPhoto: IMAGENES,
            modalShow :false,
            message: '',
            isLoading: false,
            personTeacherId : 0,
            nameTeacher : '',
            photoTeacher : '',
            ratingValue : null,
            comment: '',
            idCalification: 0,
            showRatingError: false
		}
	},
	mounted() {
	},
	methods: {
        handleHideModal(){
            this.$store.dispatch("updateFlagValidateCalifications",false); 
            
        },  
        getClose(){
            this.$store.dispatch("updateFlagValidateCalifications",false); 
            this.$bvModal.hide('modal-score-teacher');
        },
        
        registerScore(){
            if(!this.ratingValue){
                this.showRatingError = true;
                return;
            }
            this.showRatingError = false;
            this.isLoading = true;
            let json = {
                Id: this.idCalification,
                PersonTeacherId: this.personTeacherId,
                Qualification: this.ratingValue,
                Commentary: this.comment,
                PersonStudentId :this.$store.state.user.personStudentId,
                UserCreated : this.$store.state.user.email
            }
            baseInstanceAxios
                .post(`${this.apiURL}/resources/PersonsTeachers/SaveCalification `, json)
                .then(response => {
                      if(response.data.value>0){
                        //this.$store.dispatch("updateFlagValidateCalifications",false)
                        this.$emit('close-window-recommend')
                        this.isLoading  = false;
                        /*this.comment = '';
                        this.ratingValue = 0;*/
                        this.modalShow = false;
                    }
                 
                })
               /* .catch(error => {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-score");
                    this.isLoading = false;
                });*/
            
          
        },
        getShowModalScoreTeacher(item){
            this.personTeacherId = item.personTeacherId;
            this.nameTeacher = item.nameTeacher;
            this.photoTeacher = item.photoTeacher;
            this.ratingValue = item.qualification;
            this.comment = item.commentary;
            this.idCalification = item.id;
            this.showRatingError = false;
            this.modalShow = true;
        },
        registerScoreIA(){
            this.isLoading = true;
         
        },

        
	}

}
</script>